const baseUrl = "/v1/admin/government-contact"
export const API_URL = {
    LIST: `${baseUrl}`,
    CREATE: `${baseUrl}/create`,
    DETAILS: (id: number): string => `${baseUrl}/${id}/details`,
    DELETE: (id: number): string => `${baseUrl}/${id}/delete`,
    UPDATE: (id: number): string => `${baseUrl}/${id}/update`,
}